export default __webpack_public_path__ + "76ddbc0da3ecd024d998df1eb4d0c0c1.png";